(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3663],{

/***/ 9215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78015);
/* harmony import */ var _ab_input_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_input_scss__WEBPACK_IMPORTED_MODULE_3__);







var Input = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, value = _param.value, onChange = _param.onChange, className = _param.className, label = _param.label, placeholder = _param.placeholder, error = _param.error, parentClassName = _param.parentClassName, placeHolderClassname = _param.placeHolderClassname, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "type",
        "value",
        "onChange",
        "className",
        "label",
        "placeholder",
        "error",
        "parentClassName",
        "placeHolderClassname"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var renderInput = function() {
        if (parentClassName == "at-novartis") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value: value,
                        onChange: function(e) {
                            return onChange(e.target.value);
                        },
                        placeholder: placeholder
                    }, rest)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : ""),
                        type: type,
                        value:  true ? "@novartis.com" : 0,
                        placeholder: placeholder
                    }, rest), {
                        disabled: true
                    }))
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: "ab-input".concat(className ? " ".concat(className) : "").concat(error ? " error" : "", " ").concat(placeHolderClassname || ""),
            type: showPassword ? "text" : type,
            value: value,
            onChange: function(e) {
                return type !== "checkbox" && type !== "radio" ? onChange(e.target.value) : onChange(e.target.checked);
            },
            checked: value,
            placeholder: placeholder
        }, rest));
    };
    // if (type == "text" || type == "password") {
    //   return renderInput();
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "ab-input container ".concat(type, " ").concat(parentClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: label
            }),
            renderInput(),
            type == "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "password",
                role: "button",
                onClick: function() {
                    return setShowPassword(!showPassword);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: showPassword ? "/images/hide.png" : "/images/show.png",
                    style: {
                        width: 16,
                        height: 16
                    },
                    alt: showPassword ? "hide" : "show"
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "checkmark"
            }),
            error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "error",
                children: error
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 3663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ab_pdp_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(62062);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-cta/src/index.jsx + 6 modules
var ab_cta_src = __webpack_require__(92114);
// EXTERNAL MODULE: ../packages/ab-premios/src/ab-premios.scss
var ab_premios = __webpack_require__(38553);
;// CONCATENATED MODULE: ../packages/ab-premios/src/index.tsx




var Premios = function(param) {
    var wine = param.wine, premios = param.premios, i18n = param.i18n;
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    if (wine) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "ab-premios".concat(wine ? " wine" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "h2",
                    children: t("premios")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: premios === null || premios === void 0 ? void 0 : premios.map(function(itm) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            children: [
                                (itm === null || itm === void 0 ? void 0 : (ref = itm.imagen) === null || ref === void 0 ? void 0 : ref.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: itm === null || itm === void 0 ? void 0 : (ref1 = itm.imagen) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl,
                                        alt: itm.nombre
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                    element: "span",
                                    className: "title",
                                    children: itm.nombre
                                })
                            ]
                        });
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-premios".concat(wine ? " wine" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "h2",
                children: t("premios")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/estrella_michelin.svg",
                                    alt: t("estrella-michelin")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("estrella-michelin")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/estrella_verde_michelin.svg",
                                    alt: t("estrella-verde")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("estrella-verde")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/repsol.svg",
                                        alt: t("soles-repsol")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/repsol.svg",
                                        alt: t("soles-repsol")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("soles-repsol")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_premios_src = (Premios);

// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-info-additional/src/ab-info-additional.scss
var ab_info_additional = __webpack_require__(27331);
;// CONCATENATED MODULE: ../packages/ab-info-additional/src/index.tsx





var AdditionalInfo = function(param) {
    var variedad = param.variedad, denomination = param.denomination, denominacionDeOrigen = param.denominacionDeOrigen, conservacion = param.conservacion, vida = param.vida, i18n = param.i18n, alergenos = param.alergenos, gradoAlcoholico = param.gradoAlcoholico, informacionNutricional = param.informacionNutricional, elaboradoYEmbotelladoPor = param.elaboradoYEmbotelladoPor, ingredientes = param.ingredientes;
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    if (!variedad && !denomination && !denominacionDeOrigen && !conservacion && !vida && !alergenos && !gradoAlcoholico && !informacionNutricional && !elaboradoYEmbotelladoPor) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-info-additional",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: t("informacion-adicional")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    variedad ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("variedad")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: variedad
                            })
                        ]
                    }) : null,
                    denomination ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("denominacion")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: denomination
                            })
                        ]
                    }) : null,
                    denominacionDeOrigen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("denominacion")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: denominacionDeOrigen
                            })
                        ]
                    }) : null,
                    conservacion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("conservacion")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: conservacion
                            })
                        ]
                    }) : null,
                    vida ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("vida")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: vida
                            })
                        ]
                    }) : null,
                    alergenos ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("alergenos")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: alergenos
                            })
                        ]
                    }) : null,
                    gradoAlcoholico ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("gradoAlcoholico")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: gradoAlcoholico
                            })
                        ]
                    }) : null,
                    informacionNutricional ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("informacionNutricional")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: informacionNutricional
                            })
                        ]
                    }) : null,
                    elaboradoYEmbotelladoPor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: t("elaboradoYEmbotelladoPor")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: elaboradoYEmbotelladoPor
                            })
                        ]
                    }) : null,
                    ingredientes ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                style: {
                                    marginBottom: 15
                                },
                                children: t("ingredientes")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                                prefetch: false,
                                text: ingredientes.title,
                                href: ingredientes.url,
                                target: ingredientes.target
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_info_additional_src = (AdditionalInfo);

// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-personalizacion/src/index.tsx
var ab_personalizacion_src = __webpack_require__(36149);
// EXTERNAL MODULE: ../packages/ab-context-cart/src/index.tsx + 3 modules
var ab_context_cart_src = __webpack_require__(29359);
// EXTERNAL MODULE: ../packages/ab-functions/src/index.tsx + 9 modules
var ab_functions_src = __webpack_require__(5134);
// EXTERNAL MODULE: ../packages/ab-pdp/src/ab-pdp.scss
var ab_pdp = __webpack_require__(90662);
;// CONCATENATED MODULE: ../packages/ab-pdp/src/index.tsx



















var PDP = function(param) {
    var name = param.name, description = param.description, productos_ingles = param.productos_ingles, productos_aleman = param.productos_aleman, attributes = param.attributes, products = param.products, price = param.price, type = param.type, databaseId = param.databaseId, stockQuantity = param.stockQuantity, stockStatus = param.stockStatus, image = param.image, groupedProductIngles = param.groupedProductIngles, groupedProductAleman = param.groupedProductAleman, productCategories = param.productCategories, galleryImages = param.galleryImages, language = param.language, metaData = param.metaData, personalizacion = param.personalizacion, etiquetaSKU = param.etiquetaSKU, i18n = param.i18n;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76;
    // console.log("PDP - etiquetaSKU - ", productCategories);
    // console.log("PDP - galleryImages Product - ", galleryImages);
    // console.log("PDP - productos_ingles - ", language, groupedProductIngles);
    var ref77 = (0,react.useState)(), selectedProduct = ref77[0], setSelectedProduct = ref77[1];
    var ref78 = (0,react.useState)(false), stockError = ref78[0], setStockError = ref78[1];
    var ref79 = (0,react.useState)(1), numBotellas = ref79[0], setNumBotellas = ref79[1];
    var ref80 = (0,_sliced_to_array/* default */.Z)((0,ab_context_cart_src/* useCartContext */.iQ)(), 2), state = ref80[0], dispatch = ref80[1];
    var addItemToCart = dispatch.addItemToCart;
    var ref81 = (0,react.useState)(), selectedAnada = ref81[0], selectAnada = ref81[1];
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    var esProductoFinca = function() {
        var ref;
        return productCategories === null || productCategories === void 0 ? void 0 : (ref = productCategories.nodes) === null || ref === void 0 ? void 0 : ref.find(function(itm) {
            return i18n.language == "en" ? "Products from the Estate" : i18n.language == "de" ? "Produkte vom Weingut" : "Productos de la Finca";
        });
    };
    // boolean para mostrar o no personalizacion
    var nuestrosVinos = function() {
        var ref;
        return productCategories === null || productCategories === void 0 ? void 0 : (ref = productCategories.nodes) === null || ref === void 0 ? void 0 : ref.find(function(itm) {
            var category = "Vinos con Denominaci\xf3n de Origen Protegida";
            return category === itm.name;
        });
    };
    var esNuestrosVinos = nuestrosVinos();
    var seleccionNavidad = function() {
        var ref;
        return productCategories === null || productCategories === void 0 ? void 0 : (ref = productCategories.nodes) === null || ref === void 0 ? void 0 : ref.find(function(itm) {
            var category = "Un vino para los tuyos a un precio especial";
            return category === itm.name;
        });
    };
    // console.log("PDP - productCategories - ", productCategories);
    // TODO añadir +1 por cada botella añadida --> count
    var customiceLabelPrice = (personalizacion === null || personalizacion === void 0 ? void 0 : personalizacion.price) || 5;
    var etiquetaPrice = (etiquetaSKU === null || etiquetaSKU === void 0 ? void 0 : etiquetaSKU.price) || 1;
    // console.log(
    //   "parseFloat(customiceLabelPrice)",
    //   parseWCPriceToFloat(customiceLabelPrice) +
    //     numBotellas * parseWCPriceToFloat(etiquetaPrice)
    // );
    var ref82 = (0,react.useState)(false), personalizeEtiqueta = ref82[0], setPersonalizeEtiqueta = ref82[1];
    var ref83 = (0,react.useState)(""), etiquetaText = ref83[0], setEtiquetaText = ref83[1];
    // console.log("#### PDP - groupedProductIngles - ", groupedProductIngles);
    // console.log("#### PDP - description - ", description);
    var _description = i18n.language == "en" ? (productos_ingles === null || productos_ingles === void 0 ? void 0 : productos_ingles.contentIngles) || (groupedProductIngles === null || groupedProductIngles === void 0 ? void 0 : groupedProductIngles.description) || description : i18n.language == "de" ? (productos_aleman === null || productos_aleman === void 0 ? void 0 : productos_aleman.contentAleman) || (groupedProductAleman === null || groupedProductAleman === void 0 ? void 0 : groupedProductAleman.descriptionAleman) || description : description;
    _description = esProductoFinca() ? description : _description;
    var notasDeCata = type === "SIMPLE" ? (ref = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_de_cata";
    })) === null || ref === void 0 ? void 0 : ref.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref1 = selectedProduct.productos) === null || ref1 === void 0 ? void 0 : ref1.notasDeCata;
    var notasDeCataIngles = type === "SIMPLE" ? (ref2 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_de_cata_ingles";
    })) === null || ref2 === void 0 ? void 0 : ref2.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref3 = selectedProduct.productos_ingles) === null || ref3 === void 0 ? void 0 : ref3.notasDeCataIngles;
    var notasDeCataAleman = type === "SIMPLE" ? (ref4 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_de_cata_aleman";
    })) === null || ref4 === void 0 ? void 0 : ref4.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref5 = selectedProduct.productos_aleman) === null || ref5 === void 0 ? void 0 : ref5.notasDeCataAleman;
    var notasAnada = type === "SIMPLE" ? (ref6 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_anada";
    })) === null || ref6 === void 0 ? void 0 : ref6.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref7 = selectedProduct.productos) === null || ref7 === void 0 ? void 0 : ref7.notasAnada;
    var notasAnadaIngles = type === "SIMPLE" ? (ref8 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_anada_ingles";
    })) === null || ref8 === void 0 ? void 0 : ref8.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref9 = selectedProduct.productos_ingles) === null || ref9 === void 0 ? void 0 : ref9.notasAnadaIngles;
    var notasAnadaAleman = type === "SIMPLE" ? (ref10 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "notas_anada_aleman";
    })) === null || ref10 === void 0 ? void 0 : ref10.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref11 = selectedProduct.productos_aleman) === null || ref11 === void 0 ? void 0 : ref11.notasAnadaAleman;
    var premios = type === "SIMPLE" ? (ref12 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "premios";
    })) === null || ref12 === void 0 ? void 0 : ref12.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref13 = selectedProduct.productos) === null || ref13 === void 0 ? void 0 : ref13.premios;
    var premiosIngles = type === "SIMPLE" ? (ref14 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "premios_ingles";
    })) === null || ref14 === void 0 ? void 0 : ref14.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref15 = selectedProduct.productos_ingles) === null || ref15 === void 0 ? void 0 : ref15.premiosIngles;
    var premiosAleman = type === "SIMPLE" ? (ref16 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
        return itm.key == "premios_aleman";
    })) === null || ref16 === void 0 ? void 0 : ref16.value : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref17 = selectedProduct.productos_aleman) === null || ref17 === void 0 ? void 0 : ref17.premiosAleman;
    var infoAddicional = type === "SIMPLE" ? {
        variedad: (ref18 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_variedad";
        })) === null || ref18 === void 0 ? void 0 : ref18.value,
        conservacion: (ref19 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_conservacion";
        })) === null || ref19 === void 0 ? void 0 : ref19.value,
        denominacionDeOrigen: (ref20 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_denominacion_de_origen";
        })) === null || ref20 === void 0 ? void 0 : ref20.value,
        vida: (ref21 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_vida";
        })) === null || ref21 === void 0 ? void 0 : ref21.value,
        alergenos: (ref22 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_alergenos";
        })) === null || ref22 === void 0 ? void 0 : ref22.value,
        gradoAlcoholico: (ref23 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_grado_alcoholico";
        })) === null || ref23 === void 0 ? void 0 : ref23.value,
        informacionNutricional: (ref24 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_informacion_nutricional";
        })) === null || ref24 === void 0 ? void 0 : ref24.value,
        elaboradoYEmbotelladoPor: (ref25 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_elaborado_y_embotellado_por";
        })) === null || ref25 === void 0 ? void 0 : ref25.value,
        ingredientes: (ref26 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingredientes";
        })) === null || ref26 === void 0 ? void 0 : ref26.value
    } : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref27 = selectedProduct.productos) === null || ref27 === void 0 ? void 0 : ref27.infoAddicional;
    var infoAddicionalIngles = type === "SIMPLE" ? {
        variedad: (ref28 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_variedad";
        })) === null || ref28 === void 0 ? void 0 : ref28.value,
        conservacion: (ref29 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_conservacion";
        })) === null || ref29 === void 0 ? void 0 : ref29.value,
        denominacionDeOrigen: (ref30 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_denominacion_de_origen";
        })) === null || ref30 === void 0 ? void 0 : ref30.value,
        vida: (ref31 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_vida";
        })) === null || ref31 === void 0 ? void 0 : ref31.value,
        alergenos: (ref32 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_alergenos";
        })) === null || ref32 === void 0 ? void 0 : ref32.value,
        gradoAlcoholico: (ref33 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_grado_alcoholico";
        })) === null || ref33 === void 0 ? void 0 : ref33.value,
        informacionNutricional: (ref34 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_informacion_nutricional";
        })) === null || ref34 === void 0 ? void 0 : ref34.value,
        elaboradoYEmbotelladoPor: (ref35 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_elaborado_y_embotellado_por";
        })) === null || ref35 === void 0 ? void 0 : ref35.value,
        ingredientes: (ref36 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_ingles_ingredientes";
        })) === null || ref36 === void 0 ? void 0 : ref36.value
    } : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref37 = selectedProduct.productos_ingles) === null || ref37 === void 0 ? void 0 : ref37.infoAddicionalIngles;
    var infoAddicionalAleman = type === "SIMPLE" ? {
        variedad: (ref38 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_variedad";
        })) === null || ref38 === void 0 ? void 0 : ref38.value,
        conservacion: (ref39 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_conservacion";
        })) === null || ref39 === void 0 ? void 0 : ref39.value,
        denominacionDeOrigen: (ref40 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_denominacion_de_origen";
        })) === null || ref40 === void 0 ? void 0 : ref40.value,
        vida: (ref41 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_vida";
        })) === null || ref41 === void 0 ? void 0 : ref41.value,
        alergenos: (ref42 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_alergenos";
        })) === null || ref42 === void 0 ? void 0 : ref42.value,
        gradoAlcoholico: (ref43 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_grado_aleman_alcoholico";
        })) === null || ref43 === void 0 ? void 0 : ref43.value,
        informacionNutricional: (ref44 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_informacion_nutricional";
        })) === null || ref44 === void 0 ? void 0 : ref44.value,
        elaboradoYEmbotelladoPor: (ref45 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_elaborado_y_embotellado_por";
        })) === null || ref45 === void 0 ? void 0 : ref45.value,
        ingredientes: (ref46 = metaData === null || metaData === void 0 ? void 0 : metaData.find(function(itm) {
            return itm.key == "info_addicional_aleman_ingredientes";
        })) === null || ref46 === void 0 ? void 0 : ref46.value
    } : selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref47 = selectedProduct.productos_aleman) === null || ref47 === void 0 ? void 0 : ref47.infoAddicionalAleman;
    var handleAddToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(product, count, authToken) {
            var addons, ref, extraData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        addons = [];
                        if (personalizeEtiqueta && etiquetaText) {
                            ;
                            addons.push({
                                name: "Servicio de personalizacion",
                                price: "0",
                                value: "Si"
                            });
                            addons.push({
                                name: "Texto para la etiqueta",
                                price: ((ref = (0,ab_functions_src/* parseWCPriceToFloat */.Sl)(etiquetaPrice)) === null || ref === void 0 ? void 0 : ref.toFixed(2)) || "1",
                                value: etiquetaText
                            });
                            addons.push({
                                name: "Nuestros vinos",
                                price: "",
                                value: product.name
                            });
                        }
                        extraData = {
                            addons: addons
                        };
                        _ctx.next = 5;
                        return addItemToCart((0,_object_spread/* default */.Z)({}, product), count, authToken, JSON.stringify(extraData));
                    case 5:
                        if (!(personalizeEtiqueta && etiquetaText)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 8;
                        return addItemToCart(personalizacion, 1, authToken, null);
                    case 8:
                        return _ctx.abrupt("return", true);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAddToCart(product, count, authToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidForCustomize = function() {
        var ref;
        var res = false;
        var anadaSelected = parseInt(selectedAnada);
        var anadas = [];
        if (!attributes) {
            var ref1;
            products === null || products === void 0 ? void 0 : (ref1 = products.nodes) === null || ref1 === void 0 ? void 0 : ref1.map(function(itm) {
                var ref, ref1;
                anadas = itm === null || itm === void 0 ? void 0 : (ref = itm.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.find(function(itm) {
                    return itm.name == "A\xf1ada";
                });
            });
        } else {
            var ref2;
            anadas = attributes === null || attributes === void 0 ? void 0 : (ref2 = attributes.nodes) === null || ref2 === void 0 ? void 0 : ref2.find(function(itm) {
                return itm.name == "A\xf1ada";
            });
        }
        var ref3;
        var anadasArray = (ref3 = anadas === null || anadas === void 0 ? void 0 : anadas.options) !== null && ref3 !== void 0 ? ref3 : [];
        var sortedArray = (0,_to_consumable_array/* default */.Z)(anadasArray);
        sortedArray.sort(function(a, b) {
            return parseInt(a) - parseInt(b);
        });
        var selectedFromato = (ref = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.attributes.nodes.find(function(atr) {
            return atr.name === "Formato";
        })) === null || ref === void 0 ? void 0 : ref.options[0];
        if (selectedFromato === "0.75L") {
            res = sortedArray[sortedArray.length - 1] <= anadaSelected;
        } else if (selectedFromato === "1.5L") {
            //Especial case for 1.5L we let customize the Añada before the last one:
            // [2000, 2001, 2002] then for 1.5L 2001 is valid to customize
            res = sortedArray[sortedArray.length - 2] <= anadaSelected;
        }
        return res;
    };
    // console.log("#### PDP - attributes - ", attributes);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-pdp",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "h2",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref48 = selectedProduct.image) === null || ref48 === void 0 ? void 0 : ref48.mediaItemUrl) || (galleryImages === null || galleryImages === void 0 ? void 0 : (ref49 = galleryImages.nodes) === null || ref49 === void 0 ? void 0 : (ref50 = ref49[0]) === null || ref50 === void 0 ? void 0 : ref50.mediaItemUrl) || (image === null || image === void 0 ? void 0 : image.mediaItemUrl),
                        alt: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "".concat(esProductoFinca() ? "" : t("vino"), " ").concat(name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "h2",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cta".concat(stockError ? " stock-error" : "").concat(esNuestrosVinos ? " personalice-margin" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_cta_src["default"], {
                            type: "anadir",
                            text: t("anadir"),
                            plus: true,
                            price: price,
                            attributes: attributes === null || attributes === void 0 ? void 0 : attributes.nodes,
                            products: products === null || products === void 0 ? void 0 : products.nodes,
                            setSelectedProduct: setSelectedProduct,
                            selectedProduct: type === "SIMPLE" ? {
                                name: name,
                                price: price,
                                attributes: attributes,
                                type: type,
                                databaseId: databaseId,
                                stockQuantity: stockQuantity,
                                stockStatus: stockStatus
                            } : selectedProduct,
                            productType: type,
                            i18n: i18n,
                            setStockError: setStockError,
                            stockError: stockError,
                            esNuestrosVinos: esNuestrosVinos,
                            setNumBotellas: setNumBotellas,
                            callbackAddToCart: handleAddToCart,
                            seleccionNavidad: seleccionNavidad(),
                            selectAnada: selectAnada
                        })
                    }),
                    stockError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stock-error-text",
                        children: t("no-hay-stock")
                    }) : null,
                    isValidForCustomize() && esNuestrosVinos ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_personalizacion_src/* default */.Z, {
                        personalizeEtiqueta: personalizeEtiqueta,
                        setPersonalizeEtiqueta: setPersonalizeEtiqueta,
                        etiquetaText: etiquetaText,
                        setEtiquetaText: setEtiquetaText,
                        customiceLabelPrice: "(+".concat(numeral_default()((0,ab_functions_src/* parseWCPriceToFloat */.Sl)(customiceLabelPrice) + numBotellas * (0,ab_functions_src/* parseWCPriceToFloat */.Sl)(etiquetaPrice)).format("1,000.00$"), ")"),
                        serviceSKU: personalizacion,
                        etiquetaSKU: etiquetaSKU,
                        i18n: i18n
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                            content: _description
                        })
                    }),
                    selectedProduct || type === "SIMPLE" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref51 = selectedProduct.imagenDescripcion) === null || ref51 === void 0 ? void 0 : ref51.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref52 = selectedProduct.imagenDescripcion) === null || ref52 === void 0 ? void 0 : ref52.mediaItemUrl
                            }) : null,
                            i18n.language == "es" && premios ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_premios_src, {
                                wine: true,
                                premios: premios,
                                i18n: i18n
                            }) : null,
                            i18n.language == "en" && premiosIngles ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_premios_src, {
                                wine: true,
                                premios: premiosIngles,
                                i18n: i18n
                            }) : null,
                            i18n.language == "de" && premiosAleman ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_premios_src, {
                                wine: true,
                                premios: premiosAleman,
                                i18n: i18n
                            }) : null,
                            i18n.language == "en" && notasDeCataIngles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: t("notas-de-cata")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasDeCataIngles
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref53 = selectedProduct.imagenCata) === null || ref53 === void 0 ? void 0 : ref53.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref54 = selectedProduct.imagenCata) === null || ref54 === void 0 ? void 0 : ref54.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "de" && (notasDeCataAleman || notasDeCataIngles) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: t("notas-de-cata")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasDeCataAleman || notasDeCataIngles
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref55 = selectedProduct.imagenCata) === null || ref55 === void 0 ? void 0 : ref55.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref56 = selectedProduct.imagenCata) === null || ref56 === void 0 ? void 0 : ref56.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "es" && notasDeCata ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: t("notas-de-cata")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasDeCata
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref57 = selectedProduct.imagenCata) === null || ref57 === void 0 ? void 0 : ref57.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref58 = selectedProduct.imagenCata) === null || ref58 === void 0 ? void 0 : ref58.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "en" && notasAnadaIngles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: "".concat(((ref61 = selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref59 = selectedProduct.attributes) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.nodes) === null || ref60 === void 0 ? void 0 : ref60.find(function(itm) {
                                            return itm.name == "A\xf1ada";
                                        })) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.options) === null || ref62 === void 0 ? void 0 : ref62[0]) || "", " Vintage")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasAnadaIngles
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref63 = selectedProduct.imagenAnada) === null || ref63 === void 0 ? void 0 : ref63.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref64 = selectedProduct.imagenAnada) === null || ref64 === void 0 ? void 0 : ref64.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "de" && (notasAnadaAleman || notasAnadaIngles) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: "Jahrgang ".concat(((ref67 = selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref65 = selectedProduct.attributes) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.nodes) === null || ref66 === void 0 ? void 0 : ref66.find(function(itm) {
                                            return itm.name == "A\xf1ada";
                                        })) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.options) === null || ref68 === void 0 ? void 0 : ref68[0]) || "", " ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasAnadaAleman || notasAnadaIngles
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref69 = selectedProduct.imagenAnada) === null || ref69 === void 0 ? void 0 : ref69.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref70 = selectedProduct.imagenAnada) === null || ref70 === void 0 ? void 0 : ref70.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "es" && notasAnada ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        element: "h2",
                                        className: "mobile",
                                        style: {
                                            marginTop: 92
                                        },
                                        children: "A\xf1ada ".concat(((ref73 = selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref71 = selectedProduct.attributes) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.nodes) === null || ref72 === void 0 ? void 0 : ref72.find(function(itm) {
                                            return itm.name == "A\xf1ada";
                                        })) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.options) === null || ref74 === void 0 ? void 0 : ref74[0]) || "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                            content: notasAnada
                                        })
                                    }),
                                    (selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref75 = selectedProduct.imagenAnada) === null || ref75 === void 0 ? void 0 : ref75.mediaItemUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref76 = selectedProduct.imagenAnada) === null || ref76 === void 0 ? void 0 : ref76.mediaItemUrl
                                    }) : null
                                ]
                            }) : null,
                            i18n.language == "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_info_additional_src, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoAddicionalIngles), {
                                i18n: i18n
                            })) : i18n.language == "de" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_info_additional_src, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoAddicionalAleman), {
                                i18n: i18n
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_info_additional_src, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoAddicional), {
                                i18n: i18n
                            }))
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_pdp_src = (PDP);


/***/ }),

/***/ 36149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62062);
/* harmony import */ var ab_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9215);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(145);
/* harmony import */ var _ab_personalizacion_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73600);
/* harmony import */ var _ab_personalizacion_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ab_personalizacion_scss__WEBPACK_IMPORTED_MODULE_4__);





var Personalizacion = function(param) {
    var configuradorEstuches = param.configuradorEstuches, i18n = param.i18n, customiceLabelPrice = param.customiceLabelPrice, isEven = param.isEven, // etiqueta
    personalizeEtiqueta = param.personalizeEtiqueta, setPersonalizeEtiqueta = param.setPersonalizeEtiqueta, etiquetaText = param.etiquetaText, setEtiquetaText = param.setEtiquetaText, // tarjeton
    personalizeMessage = param.personalizeMessage, setPersonalizeMessage = param.setPersonalizeMessage, tarjetaText = param.tarjetaText, setTarjetaText = param.setTarjetaText, isEstuche = param.isEstuche, serviceSKU = param.serviceSKU, etiquetaSKU = param.etiquetaSKU;
    var ref, ref1, ref2;
    // return null;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    var nuevaEtiqueta = "https://abadia.glbcrt.com/wp-content/uploads/personalizacion.png";
    var imagenEtiqueta = isEstuche ? (configuradorEstuches === null || configuradorEstuches === void 0 ? void 0 : (ref = configuradorEstuches.imagenTirilla) === null || ref === void 0 ? void 0 : ref.mediaItemUrl) || nuevaEtiqueta : nuevaEtiqueta;
    // console.log("configuradorEstuches", configuradorEstuches);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "personalizacion ".concat(isEven ? "even" : "odd").concat(!isEstuche ? " our-wine" : ""),
        children: [
            isEstuche ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                element: "h3",
                children: t("toque")
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "checkbox",
                label: "".concat(t("customize"), " ").concat(customiceLabelPrice),
                value: personalizeEtiqueta,
                onChange: function(val) {
                    return setPersonalizeEtiqueta(val);
                }
            }),
            personalizeEtiqueta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            marginLeft: 45,
                            marginTop: -10
                        },
                        children: "- ".concat(serviceSKU === null || serviceSKU === void 0 ? void 0 : serviceSKU.name, ": (+").concat(serviceSKU === null || serviceSKU === void 0 ? void 0 : serviceSKU.price, ")")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        element: "p",
                        style: {
                            marginLeft: 45,
                            marginTop: 0,
                            marginBottom: 25
                        },
                        children: "- ".concat(t("personalizacion"))
                    })
                ]
            }) : null,
            personalizeEtiqueta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                placeholder: t("labelText"),
                value: etiquetaText,
                onChange: function(val) {
                    return setEtiquetaText(val === null || val === void 0 ? void 0 : val.substring(0, 25));
                }
            }) : null,
            personalizeEtiqueta && imagenEtiqueta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                srcSet: configuradorEstuches === null || configuradorEstuches === void 0 ? void 0 : configuradorEstuches.imagenTirilla,
                                media: "(max-width: 450px)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: imagenEtiqueta,
                                loading: "lazy",
                                width: 350,
                                className: "zoom-image"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        element: "p",
                        style: {
                            marginLeft: 75,
                            marginTop: 5
                        },
                        children: t("personalizacion-ejemplo")
                    })
                ]
            }) : null,
            isEstuche ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "checkbox",
                        label: t("addNote"),
                        value: personalizeMessage,
                        onChange: function(val) {
                            return setPersonalizeMessage(val);
                        }
                    }),
                    personalizeMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                        placeholder: t("note"),
                        value: tarjetaText,
                        onChange: function(e) {
                            var ref;
                            return setTarjetaText((ref = e.target.value) === null || ref === void 0 ? void 0 : ref.substring(0, 200));
                        }
                    }) : null,
                    personalizeMessage && (configuradorEstuches === null || configuradorEstuches === void 0 ? void 0 : (ref1 = configuradorEstuches.imagenTarjeton) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                srcSet: configuradorEstuches === null || configuradorEstuches === void 0 ? void 0 : configuradorEstuches.imagenTarjeton,
                                media: "(max-width: 350px)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: configuradorEstuches === null || configuradorEstuches === void 0 ? void 0 : (ref2 = configuradorEstuches.imagenTarjeton) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl,
                                loading: "lazy",
                                width: 350
                            })
                        ]
                    }) : null
                ]
            }) : null,
            personalizeEtiqueta || personalizeMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                element: "span",
                className: "deliveryNote",
                children: t("deliveryTime")
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Personalizacion);


/***/ }),

/***/ 27331:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78015:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 90662:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73600:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38553:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);